import { useMutation } from 'react-query';
import axios from 'axios';
import { useTokenStore } from '../../storage/tokenState';
import { GET_SUBSCRIPTION_STATUS } from '../../appConstants/APIEndpoint';
import { LANGUAGE } from '../../constant';
import { getSubscriptionBaseUrl } from '../../utils/apiConfig';

interface SubscriptionStatusResponse {
  en: string;
  response: {
    success: boolean;
    data?: {
      activeSubscriptionsData?: {
        ZUPEE_TV?: {
          isActive: boolean;
          mandatePaymentStore: string;
          validityTill: number;
          restoreSubscription: boolean;
        };
      };
    };
  };
}

export const useGetSubscriptionStatus = () => {
  const { token } = useTokenStore();

  const mutation = useMutation<SubscriptionStatusResponse, Error, void>(
    async () => {
      // Get base URL from environment (trailing slash already removed in apiConfig)
      const baseUrl = getSubscriptionBaseUrl();
      const fullUrl = `${baseUrl}${GET_SUBSCRIPTION_STATUS.url}`;
      
      console.log('Calling getSubscriptionStatus API:', {
        url: fullUrl,
        hasToken: !!token?.accessToken
      });

      const response = await axios.post(fullUrl, {}, {
        headers: {
          'Accept': 'application/json',
          'Authorization': token?.accessToken || '',
          'x-zupee-source': 'web',
          // 'x-zupee-env': 'cse',
          // "z-stage-env-id":"stv-prya80a3bac",
          'language': localStorage.getItem("language") || LANGUAGE,
          'Content-Type': 'application/json',
          'Package-Name': process.env.REACT_APP_APPPACKAGENAME || 'pwa.verticalbyzupee.com',
          'appname': process.env.REACT_APP_APP_NAME || 'pwa.verticalbyzupee.com',

        }
      });

      console.log('getSubscriptionStatus Response:', response.data);
      return response.data;
    }
  );

  return {
    checkSubscriptionStatus: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    data: mutation.data,
    error: mutation.error
  };
};

